/**
 * Enmascara una dirección de wallet dejando visibles los primeros y últimos
 * 6 caracteres (ej. `0x1a2b3c...9f8e7d`). Valores de 12 caracteres o menos se
 * devuelven sin cambios para no ocultar direcciones ya cortas.
 *
 * @param value - Dirección o identificador de wallet a enmascarar.
 * @returns El valor enmascarado, o el original si tiene 12 caracteres o menos.
 */
export function maskWalletAddress(value: string): string {
  if (!value || value.length <= 12) return value;
  return `${value.slice(0, 6)}...${value.slice(-6)}`;
}
